<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    show-close
    width="400px"
    :title="title || defaultTitle"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main
      ref="main"
      :fileType="fileType"
      @close="close()"
      @reload="$emit('reload')"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.main.upload()">
        {{ $l('INDEX.btn_upload') || '上传' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    fileType: { type: String, default: '' },
  },
  data() {
    return {
      defaultTitle:
        this.$l('INDEX.dialog_title_ecom_upload_file') ||
        '上传文件',
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
